import type { ComponentType } from 'react';
import type { RouteObject } from 'react-router';

/** apps/web が集約する。ルート単位で遅延ロード（03 第 I 部 §2） */
type PageModule = { default: ComponentType };

function page(load: () => Promise<PageModule>): RouteObject['lazy'] {
  return async () => {
    const m = await load();
    return { Component: m.default };
  };
}

export const conversationRoutes: RouteObject[] = [
  { path: '/conversation', lazy: page(() => import('./pages/ConversationListPage.js')) },
  // 管理: システム投稿の種類ごとの ON / OFF（§12.5-3）。固定パスなので :id より先に置く
  { path: '/conversation/settings', lazy: page(() => import('./pages/SystemPostSettingsPage.js')) },
  { path: '/conversation/:id', lazy: page(() => import('./pages/ConversationPage.js')) },
];
